<template>
  <mdb-container fluid class="bv-example-row">
    <mbcarouselmain class="mbcarouselmain" />
  </mdb-container>
</template>

<script>
import mbcarouselmain from '@/components/mobile/MbCarouselMain.vue';

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  components: {
    mbcarouselmain,
  },
};
</script>

<style scoped>
.bv-example-row {
  margin-top: 58px;
}

.brow{
  max-width: 100%;
  height: auto;
  padding: 0px 0px;
  margin: 0px 0px;
}

.container-fluid {
  max-width: 100%;
  height: auto;
  padding-left: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -ms-flex: 0 1 auto;
  -webkit-box-flex: 0;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color:#ffba00 !important;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  -webkit-transition: opacity .6s ease;
  transition: opacity .6s ease;
}
</style>
